/* eslint-disable react/prop-types */
import React from 'react';
import InfoIcon from '@material-ui/icons/Info';
import { Tooltip } from '@material-ui/core';

const customTooltip = ({ text, style = { position: 'absolute', top: 10, right: 10 } }) => (
  <Tooltip title={<span style={{ fontSize: 15 }}>{text}</span>} arrow>
    <div style={style}>
      <InfoIcon style={{ color: '#B5B5B6', fontSize: 16 }} aria-label="info icon" />
    </div>
  </Tooltip>
);

export default customTooltip;
